var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAFlagGermany = function SvgAFlagGermany(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H0V14H18V0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4.66667H0V14H18V4.66667Z",
    fill: "#DD0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.33333H0V14H18V9.33333Z",
    fill: "#FFCE00"
  })));
};
export { SvgAFlagGermany as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxOCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4IDBIMFYxNEgxOFYwWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE4IDQuNjY2NjdIMFYxNEgxOFY0LjY2NjY3WiIgZmlsbD0iI0REMDAwMCIvPgo8cGF0aCBkPSJNMTggOS4zMzMzM0gwVjE0SDE4VjkuMzMzMzNaIiBmaWxsPSIjRkZDRTAwIi8+Cjwvc3ZnPgo=";